import * as React from 'react';

interface IProps {
  isExpanded: boolean;
  setIsExpanded(expanded: boolean): void;
}

export function ToggleExpanded({ isExpanded, setIsExpanded }: IProps) {
  const text = isExpanded ? 'Close' : 'Show';
  const caret = isExpanded ? 'up' : 'down';

  return (
    <div className="frow frow--centered">
      <button
        type="button"
        className="external-panel__link text-center pad-a-2 mar-b-2"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ background: 'none', border: 'none' }}
      >
        {text} Filters
        <i className={`fal fa-fw fa-angle-${caret}`} />
      </button>
    </div>
  );
}
